import React from 'react';
import { Grid, GridColumn, Container, Header } from 'semantic-ui-react';
import ContactCard from '../shared/ContactCard';
import MyCompany from '../shared/MyCompany';
import '../styles.scss';

const InstallerDashboard: React.FC = () => {

    window.location.assign('/my-deals');

    return (
        <div id="installer-dashboard" className="dashboard">
            <Container>
                <Grid stackable>
                    <GridColumn width={12}>
                        <Header as="h1">Dashboard</Header>
                    </GridColumn>
                    <GridColumn computer={8} tablet={12} mobile={16}>
                    </GridColumn>
                    <GridColumn computer={4} tablet={12} mobile={16}>
                        <ContactCard />
                        <MyCompany />
                    </GridColumn>
                </Grid>
            </Container>
        </div>
    );
};

export default InstallerDashboard;